import { Tenant } from 'new/types/tenants';
import pngLogo from 'new/assets/logos/DHQ-logo-standard-ltbkgrd_cropped.png';
import pngLogoSmall from 'new/assets/logos/DHQ-logo-small.png';
import pngLogoOnLight from 'new/assets/logos/DHQ-logo-DHQblue_cropped.png';
import pngLogoWhite from 'new/assets/logos/DHQ-logo-allwhite-cropped.png';
import { ReactComponent as SvgLogo } from 'new/assets/logos/DHQ-ondark-cropped.svg';
import { ReactComponent as SvgLogoSmall } from 'new/assets/logos/DHQ-logo-small-cropped.svg';
import { ReactComponent as SvgLogoOnLight } from 'new/assets/logos/DHQ-logo-DHQ blue-cropped.svg';
import favIcon from 'assets/favicon_dhq.ico';
import loginBg from 'new/assets/login_bg.png';
import {
  jobTitleOptions,
  launchChecklistItems,
  leadSourceOptions,
  locationInfoList2,
  pmsPlanOptions,
  scriptingPdf,
  templateOptions,
  customThemeValue,
  defaultImage,
  customImages,
} from '../constants/const.dhq';
import cardFront from 'new/assets/cardFront.jpg';
import cardBack from 'new/assets/cardBack.jpg';

const dhq: Tenant = {
  id: 'dhq',
  name: 'DentalHQ',
  shortName: 'DHQ',
  nameSimple: 'Dental',
  supportEmail: 'support@dentalhq.com',
  successEmail: 'success@dentalhq.com',
  supportPhone: '(254) DHQ-HELP',
  infoEmail: 'info@dentalhq.com',
  professionalName: 'dentist',
  professionalNamePlural: 'dentists',
  profession: 'dentistry',
  ucrName: 'UCR',
  prodUrl: 'https://app.dentalhq.com',
  prodDomain: 'dentalhq.com',
  adminButtonColor: '#00a1df',
  meta_description:
    'Join our dental membership plans and enjoy significant savings on dental care. Perfect for uninsured individuals and seniors seeking affordable dental plans nearby.',
  specialUserIds: 561,
  pmsName: 'PMS',
  planMinimum: 10,
  features: {
    setupBaa: true,
    gpp: true,
    pms: true,
    marketingOnlyLinks: false,
    businessConnect: true,
    inhouseFinancing: true,
    defaultSpecialty: null,
    upgradeOffice: true,
    seasonOfGivingWidget: true,
    feePerMember: true,
    leaderboardWidgetType: 'darkGreen',
    printMaterials: true,
    leadSource: true,
    upgradeFromOldPlatform: true,
    changePlanCoordinatorDoubleConfirm: false,
    csvSetup: true,
    payoutIssues: true,
    canDisableFamilyDiscounts: true,
    switchingBanner: true,
    multiVideoBox: true,
  },
  disabledWidgets: [],
  constants: {
    launchRewards: {
      prize30: 25,
      prize60: 50,
      prize90: 100,
    },
    seasonOfGivingUpTo: '550',
    seasonOfGivingPrize: '250',
    seasonOfGiving: [
      { members: '40+', amount: 300 },
      { members: '30-39', amount: 200 },
      { members: '20-29', amount: 100 },
    ],
    seasonOfGivingImage:
      'https://dentalhq-files.s3.amazonaws.com/DHQ+-+Member+Magic+Rewards-03.png',
    marketingTemplates:
      'https://s3.us-east-1.amazonaws.com/market_materials/Quarterly+Email+%26+Text+Blasts+(Template).docx',
    ucrPrefix: 'd',
    login: {
      fontFamilyContainer: 'Epilogue',
      fontFamilyTitle: 'Termina',
    },
    externalPatientLandingBaseUrl: '/accounts/signup/my-dentist',
    pmsPlanOptions,
    launchChecklistItems,
    leadSourceOptions,
    templateOptions,
    customThemeValue,
    defaultImage,
    customImages,
    jobTitleOptions,
    defaultMonthlyPrice: 49,
    defaultYearlyPrice: 499,
    defaultChildStartingAge: 12,
    files: {
      scriptingPdf,
      quickstartGuidePdf:
        'https://s3.us-east-1.amazonaws.com/market_materials/DHQ_Quick+Reference+Guide.pdf',
      memberSignaturePdf:
        'https://dentalhq-uploads.s3.amazonaws.com/DMP_In-office_Agreement_(generic).pdf',
      termsAndConditions:
        'https://dentalhq-uploads.s3.us-east-1.amazonaws.com/Dental+Membership+Plan+Member+-+Terms++Conditions_+February+2025.pdf',
      termsAndConditionsSpanish:
        'https://dentalhq-uploads.s3.us-east-1.amazonaws.com/Dental%2BMembership%2BPlan%2B-%2BTerms%2B%26%2BConditions_February+2025v2.pdf',
      openEnrollmentTemplate:
        'https://s3.us-east-1.amazonaws.com/market_materials/DHQ+Open+Enrollment+Email+Templates.docx',
      contentCalendar:
        'https://static.showit.co/file/e60fwEfMYbA0x9JBz7tTKA/276418/2025_social_media_content_for_dental_offices.pdf',
      monthlyTemplates:
        'https://s3.us-east-1.amazonaws.com/market_materials/Monthly+Email+Templates.docx',
    },
    onboardingCalendly: 'https://calendly.com/adorn-1231/plancreationconsult60',
    locationInfoList2,
    s3Path: 'https://dentalman_uploads.s3.amazonaws.com',
    hqOrigin: 'dentalhq',
    secretaryOfStateUrl:
      'https://help.dentalhq.com/en/articles/50-locating-verifying-your-legal-business-name',
    successOnboardingCalendly:
      'https://calendly.com/adorn-1231/plancreationconsult60?hide_gdpr_banner=1',
    elevioId: '60d607527f2a5',
    redirectToDashboardPath: '/dentist-new/members',
    quantityOptions: [
      { value: 250, label: '250', price: 79, higherPrice: 99 },
      { value: 500, label: '500', price: 99, higherPrice: 119 },
      { value: 1000, label: '1000', price: 149, higherPrice: 219 },
      { value: 1500, label: '1500', price: 199, higherPrice: 279 },
      { value: 2000, label: '2000', price: 249, higherPrice: 349 },
      { value: 5000, label: '5000', price: 399, higherPrice: 449 },
    ],
    planCountsMarketingMaterials: 4,
    marketingMaterialsType: 'card',
  },
  elevio: {
    cancellations: '108',
    trackPayments: '25',
    pricing: '107',
    changePrice: '113',
  },
  logos: {
    pngLogo,
    pngLogoSmall,
    pngLogoOnLight,
    pngLogoWhite,
    SvgLogo,
    SvgLogoSmall,
    SvgLogoOnLight,
    favIcon,
  },
  calendlyDemoLink:
    'https://calendly.com/dentalhq/demo?utm_source=dashboard&utm_content=referral_page',
  enrollNowPartner:
    'https://app.dentalhq.com/enroll/practice?promo=133D23PARTNER',
  enrollNow: 'https://app.dentalhq.com/enroll/practice',
  assets: {
    loginBg,
    printMaterialsFront: cardFront,
    printMaterialsBack: cardBack,
    inviteUpload:
      'https://dentalhq-uploads.s3.us-east-1.amazonaws.com/InviteUploadDHQ.png',
  },
  theme: {
    modal: {
      fontFamily: 'Barlow',
    },
  },
  awsStorageUrl: 'https://market_materials.s3.amazonaws.com',
  referCopy:
    'Help your friends take care of their smiles with our membership plan—affordable preventive care and discounts, no insurance needed.',
  priceAlert: [8445, 9343],
  faqLength: 9,
  successCancelCalendly: 'https://calendly.com/adorn-1231/30min',
  bannerBackground: '#F8E90B',
};

export default dhq;
